import { render, staticRenderFns } from "./OverdueRecall.vue?vue&type=template&id=23721e8a&scoped=true"
import script from "./OverdueRecall.vue?vue&type=script&lang=js"
export * from "./OverdueRecall.vue?vue&type=script&lang=js"
import style0 from "./OverdueRecall.vue?vue&type=style&index=0&id=23721e8a&prod&lang=scss"
import style1 from "./OverdueRecall.vue?vue&type=style&index=1&id=23721e8a&prod&lang=scss&scoped=true"
import style2 from "./OverdueRecall.scss?vue&type=style&index=2&id=23721e8a&prod&lang=scss&scoped=true&external"
import style3 from "../Followups/overdue-recall-page.scss?vue&type=style&index=3&id=23721e8a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23721e8a",
  null
  
)

export default component.exports